import React from "react";
import { SUPPORT_EMAIL } from "../brand";

export default function ReviewHelp({ reviewId }: { reviewId?: string }) {
  const subject = reviewId
    ? `Reviewed request ${reviewId}`
    : "Help with Reviewed";
  return (
    <p className="small review-help">
      {reviewId ? "Need help with this request?" : "Need help?"}{" "}
      <a
        href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`}
      >
        Contact support
      </a>
    </p>
  );
}
